<script setup lang="ts">
import {computed} from 'vue'

// @deprecated Replace this component with the Button component when the new UI is released.

type ButtonVariant = 'error' | 'info' | 'light' | 'primary' | 'secondary'

const BUTTON_VARIANT_CLASSES: Record<ButtonVariant, string> = {
  error: 'bg-new-red-500 hover:bg-new-red-600',
  info: 'bg-new-tertiary-200 hover:bg-new-tertiary-400 text-new-primary-default',
  light: 'bg-new-neutral-100 hover:bg-new-neutral-200 text-new-neutral-700',
  primary: 'bg-new-primary-default hover:bg-new-primary-hover',
  secondary: 'bg-new-secondary-default hover:bg-new-secondary-hover text-white',
}

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    iconClasses: string
    variant?: ButtonVariant
  }>(),
  {
    variant: 'primary',
  }
)

const buttonVariantClasses = computed(() =>
  props.disabled ? 'bg-new-neutral-600 cursor-not-allowed' : BUTTON_VARIANT_CLASSES[props.variant]
)
</script>

<template>
  <button :disabled="disabled" type="button">
    <div
      class="w-6 h-6 rounded-md transition-colors duration-200 flex items-center justify-center text-white text-xs"
      :class="buttonVariantClasses"
    >
      <i :class="iconClasses"></i>
    </div>
  </button>
</template>
